import { MarketList } from '@market/react';
import { OrderSummaryCartSummary } from 'typescript/types/api/solidshop';
import { CartItem } from 'typescript/apps/checkout_v3/components/order_summary/components/cart_item';
import { sortProductByHardwareOrSoftware } from 'utilities/software';

export type CartItemsProps = {
  cartSummary: OrderSummaryCartSummary[];
  isPnpSubscribed?: boolean;
  locationCount?: number;
  kioskDeviceCount?: number;
};

export const CartItems = ({
  cartSummary,
  isPnpSubscribed = false,
  locationCount = 1,
  kioskDeviceCount = 1,
}: CartItemsProps) => {
  const { software: softwareProducts, hardware: hardwareProducts } =
    sortProductByHardwareOrSoftware(cartSummary);

  return (
    <MarketList>
      {[...softwareProducts, ...hardwareProducts].map(
        (cartItem: OrderSummaryCartSummary, index: number) => (
          <CartItem
            key={index}
            label={cartItem.product_variant.title}
            cost={cartItem.amount}
            currency={cartItem.currency}
            imgSrc={cartItem.img}
            quantity={cartItem.quantity}
            serialNumber={cartItem.exchange_serial_number}
            plan={cartItem.plan}
            isSoftware={cartItem.is_software}
            isPnpSubscribed={isPnpSubscribed}
            locationCount={locationCount}
            kioskDeviceCount={kioskDeviceCount}
            baseProductKey={cartItem.base_product_key}
          />
        ),
      )}
    </MarketList>
  );
};
